import { render } from "./ShareCollectionPopup.vue?vue&type=template&id=15aff904&scoped=true"
import script from "./ShareCollectionPopup.vue?vue&type=script&lang=js"
export * from "./ShareCollectionPopup.vue?vue&type=script&lang=js"

import "./ShareCollectionPopup.vue?vue&type=style&index=0&id=15aff904&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aff904"]])

export default __exports__